import makeStyles from '@mui/styles/makeStyles';

const useClientDetailsStyles = makeStyles({
  root: {}
});

export default useClientDetailsStyles;
